import React from 'react';
import { buttonClass } from '../components/ui/Button';
import LogoSpinner from '../components/ui/LogoSpinner';
import { DOCK_MOTION } from '../components/ChatBot/flerpieDock';

/**
 * EditModeToolbar — floating bottom toolbar during dashboard customization.
 *
 * Anchored to the viewport bottom with a frosted dark glass effect.
 * Three actions: Save (primary amber), Cancel (subtle), Reset (danger text).
 * The toolbar slides up on mount for a polished entrance.
 */
const EditModeToolbar = ({ onSave, onCancel, onReset, saving }) => {
  return (
    <div
      className={`fixed bottom-0 left-[var(--flerpie-dock,0px)] right-0 z-40
                 transition-[left] ${DOCK_MOTION} animate-slideUp`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {/* Gradient fade above toolbar */}
      <div className="h-8 bg-gradient-to-t from-gray-900/95 to-transparent pointer-events-none" />

      {/* Toolbar body */}
      <div className="bg-gray-900/95 backdrop-blur-xl border-t border-gray-700/60
                      shadow-[0_-8px_32px_rgba(0,0,0,0.5)]">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
          {/* Left — context */}
          <div className="flex items-center gap-2.5 min-w-0">
            <div className="w-2 h-2 rounded-full bg-primary animate-pulse flex-shrink-0" />
            <span className="text-xs text-on-surface-variant uppercase tracking-widest font-semibold truncate">
              Customizing Dashboard
            </span>
          </div>

          {/* Right — actions (Reset separated from Save/Cancel to prevent mis-taps) */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={onReset}
              className={buttonClass('quiet')}
            >
              Reset
            </button>

            <div className="w-px h-5 bg-gray-700/50" />

            <button
              onClick={onCancel}
              className={buttonClass('tonal')}
            >
              Cancel
            </button>

            <button
              onClick={onSave}
              disabled={saving}
              aria-busy={saving}
              className={buttonClass('filled')}
            >
              {saving ? (
                <span className="flex items-center gap-1.5">
                  <LogoSpinner size="inline" />
                  Saving...
                </span>
              ) : (
                'Save Layout'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditModeToolbar;
